import { getEpgLineUp } from 'services/api/epg/channel';
import m from 'moment';
import {
  FETCH_EPG_LINEAUP_ERROR,
  FETCH_EPG_LINEAUP_SUCCESS,
  FETCH_EPG_LINEAUP_INIT
} from './constants';

export const fetchEpgLineaUp= (params = {}) => (dispatch, getState) => {
  
    const state = getState();

    const maxTimeshift =
      Math.max(
        ...Object.values(state?.linealChannel?.data).map(item => item?.timeshift),
      ) || 6;
    dispatch({ type: FETCH_EPG_LINEAUP_INIT });
  
    setTimeout(() => dispatch(fetchEpgLineaUp(params)), 6 * 3600 * 1000);
    const dateStart = m()
      .subtract(maxTimeshift, 'h')
      .format('YYYYMMDDHHMMSS');
    const dateEnd = m()
      .add(6, 'h')
      .format('YYYYMMDDHHMMSS');
    return getEpgLineUp({
      ...params,
      epg_version:state.Player?.epgVersion?.data?.epg_version,
      date_from: dateStart,
      date_to: dateEnd,
      node_id: state.user.nodeId,
      vic:'vic'
    })
      .then(data => {
        if (data.response) {
          dispatch({
            type: FETCH_EPG_LINEAUP_SUCCESS,
            payload: data.response.channels,
          });
        } else {
          console.log('error epg 1')
  
          dispatch({
            type: FETCH_EPG_LINEAUP_ERROR,
            error: new Error(data.errors.code),
          });
        }
      })
      .catch(error => {
        console.log('error epg')
        dispatch({
          type: FETCH_EPG_LINEAUP_ERROR,
          error,
        });
      });
  };